import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=3bf08dc0&scoped=true"
import script from "./MoneyInput.vue?vue&type=script&lang=js"
export * from "./MoneyInput.vue?vue&type=script&lang=js"
import style0 from "./MoneyInput.vue?vue&type=style&index=0&id=3bf08dc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf08dc0",
  null
  
)

export default component.exports